import React, { useState } from 'react';
import { Anchor, Stack, Text, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { SyncRuleFormValues } from '../sync_rule/interface';
import { applyPrefixSuffix } from '../sync_rule/templates';
import { SyncRulePreview } from '../sync_rule/SyncRulePreview';

export const OnboardingPrefixSuffix: React.FC<{
    form: UseFormReturnType<SyncRuleFormValues>;
    setDestinationTitle: (s: string) => void;
    setDestinationDescription: (s: string) => void;
    defaultTitle: string;
    defaultDescription: string;
    onSkip: () => void;
}> = ({
    form,
    setDestinationTitle,
    setDestinationDescription,
    defaultTitle,
    defaultDescription,
    onSkip,
}) => {
    const { t } = useTranslation(['app']);
    const [prefix, setPrefix] = useState('');
    const [suffix, setSuffix] = useState('');

    const applyChanges = (nextPrefix: string, nextSuffix: string) => {
        applyPrefixSuffix(
            form,
            { setDestinationTitle, setDestinationDescription },
            nextPrefix,
            nextSuffix,
            defaultTitle,
            defaultDescription,
        );
    };

    return (
        <Stack gap="lg">
            <Stack gap="xs">
                <Text size="xl" fw={600}>{t('dashboard.onboarding.step5.title')}</Text>
                <Text c="dimmed">{t('dashboard.onboarding.step5.description')}</Text>
                <Anchor component="button" type="button" size="sm" onClick={onSkip}>
                    {t('dashboard.onboarding.skip')}
                </Anchor>
            </Stack>
            <TextInput
                label={t('dashboard.onboarding.step5.prefix-label')}
                placeholder={t('dashboard.onboarding.step5.prefix-placeholder')}
                value={prefix}
                size="md"
                onChange={(e) => {
                    const value = e.currentTarget.value;
                    setPrefix(value);
                    applyChanges(value, suffix);
                }}
            />
            <TextInput
                label={t('dashboard.onboarding.step5.suffix-label')}
                placeholder={t('dashboard.onboarding.step5.suffix-placeholder')}
                value={suffix}
                size="md"
                onChange={(e) => {
                    const value = e.currentTarget.value;
                    setSuffix(value);
                    applyChanges(prefix, value);
                }}
            />
            <SyncRulePreview
                sourceTitle={defaultTitle}
                sourceDescription={defaultDescription}
                destinationTitle={form.values.summary.includes('%original%')
                    ? form.values.summary.replace('%original%', defaultTitle)
                    : form.values.summary}
                destinationDescription={defaultDescription}
                titleLabel={t('dashboard.sync.preview.title')}
                sourceLabel={t('dashboard.sync.preview.source')}
                destinationLabel={t('dashboard.sync.preview.destination')}
            />
        </Stack>
    );
};
